module.exports = __webpack_public_path__ + "img/felt.43ef7d45.png";